import GetSiHaDocumentationRequestModelBase from '../_generated/modelBases/get-si-ha-documentation-request-model-base';

export default class GetSiHaDocumentationRequestModel extends GetSiHaDocumentationRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
